import { SITE_URL } from '../resolveSEO';
import type { GameData } from '../types';

interface Input {
  url: string;
  gameData?: GameData;
}

export const buildVideoGame = ({ url, gameData }: Input) => {
  if (!gameData) return null;
  return {
    '@type': 'VideoGame',
    '@id': `${SITE_URL}/discover/games/${gameData.slug}#game`,
    name: gameData.name,
    description: gameData.description,
    image: {
      '@type': 'ImageObject',
      url: gameData.image,
    },
    numberOfPlayers: {
      '@type': 'QuantitativeValue',
      minValue: gameData.playersMin,
      maxValue: gameData.playersMax,
    },
    gamePlatform: 'Web Browser',
    genre: 'Party Game',
    playMode: [
      ...(gameData.gameType === 'Cooperative' ? ['CoOp'] : []),
      ...(gameData.playersMin === 1 ? ['SinglePlayer'] : []),
      ...(gameData.playersMax > 1 ? ['MultiPlayer'] : []),
    ],
    ...(gameData.duration && { duration: gameData.duration }),
    ...(gameData.datePublished && { datePublished: gameData.datePublished }),
    publisher: {
      '@id': `${SITE_URL}/#organization`,
    },
    mainEntityOfPage: {
      '@id': `${url}#webpage`,
    },
  };
};
